import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AdminPanel from "@/pages/AdminPanel";
import CoachPanel from "@/pages/CoachPanel";
import StudentPanel from "@/pages/StudentPanel";
import ParentPanel from "@/pages/ParentPanel";
import { Loader2 } from "lucide-react";

function Dashboard() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="animate-spin text-blue-500" size={40} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <AdminPanel />;
  if (user.role === "coach") return <CoachPanel />;
  if (user.role === "student") return <StudentPanel />;
  if (user.role === "parent") return <ParentPanel />;
  return <div className="p-10 text-center">Bilinmeyen rol</div>;
}

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
